"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "angolo-terme": {
    "aa320af7": [{
      "hkey": "8746308c",
      "slug": "angolo-terme",
      "name": "Angolo Terme",
      "primary": true,
      "skipSearch": false
    }],
    "mazzunno": [{
      "hkey": "8746308c",
      "slug": "angolo-terme",
      "name": "Angolo Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c508bc2f": [{
      "hkey": "8746308c",
      "slug": "angolo-terme",
      "name": "Angolo Terme",
      "primary": true,
      "skipSearch": false
    }],
    "terzano": [{
      "hkey": "8746308c",
      "slug": "angolo-terme",
      "name": "Angolo Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;